import React from 'react'

function PrivacyPolicy(): React.JSX.Element {

  return (
    <div className="dashboard">
      <h2>Privacy Policy</h2>
      <p>
        This is privacy policy page.
      </p>
    </div>
  )
}

export default PrivacyPolicy
